jQuery(document).ready(function ($) {
  if (window.innerWidth < 993) {
    $(".footer-block__heading").click(function () {
      // Check if the clicked h2 already has the active class
      var isActive = $(this).hasClass("active");

      // Remove active class from all h2 elements
      $(".footer-block__heading").removeClass("active");

      // If the clicked h2 was not already active, add the active class to it
      if (!isActive) {
        $(this).addClass("active");
      }

      // Slide up all other ul elements
      $(".footer-block__details-content").not($(this).next()).slideUp();

      // Slide toggle the next ul element
      $(this).next().slideToggle();
    });
  }

  $(".btn--menu").click(function () {
    $("body").addClass("mobile-menu-open");
  });

  $(".mobile-close-region").click(function () {
    $("body").removeClass("mobile-menu-open");
  });

  // $(".active-facets.active-facets-desktop").insertAfter("#FacetSortForm");
});
